import { Box } from '@mui/material';
import { node } from 'prop-types';
import React from 'react';

const legalDocSx = {
  color: 'text.primary',
  margin: '2em 0 1em 0',
  maxHeight: '80vh',
  overflow: 'auto',
  '& a': {
    color: 'link.main',
    textDecoration: 'underline',
    '&:visited': {
      color: 'link.main',
    },
    '&:active': {
      color: 'link.hover',
    },
  },
};

const LegalDoc = ({ children = null }) => (
  <Box sx={legalDocSx} dangerouslySetInnerHTML={{ __html: children }} />
);
LegalDoc.propTypes = {
  children: node,
};

export default LegalDoc;
